import { render, staticRenderFns } from "./secondCategroy.vue?vue&type=template&id=e4972e54&scoped=true"
import script from "./secondCategroy.vue?vue&type=script&lang=js"
export * from "./secondCategroy.vue?vue&type=script&lang=js"
import style0 from "./secondCategroy.vue?vue&type=style&index=0&id=e4972e54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4972e54",
  null
  
)

export default component.exports